import React, { FC, useEffect, useState } from 'react'
import style from 'styles/components/list.module.scss'
import text from 'styles/utility/text.module.scss'
import { db } from 'firebase/index'
import { CouponUserType } from 'types/coupon_user'
import { UserType } from 'types/user'
import classNames from 'classnames'

type Props = {
  couponUsers: CouponUserType[]
}

const CouponUserList: FC<Props> = (props) => {
  const { couponUsers } = props
  const [userDetails, setUserDetails] = useState<UserType[]>([])

  const fetchUser = async (id: string): Promise<UserType | undefined> => {
    try {
      const snapshot = await db.collection('users').doc(id).get()
      return snapshot.data() as UserType
    } catch (error) {
      console.error(error)
      return undefined
    }
  }

  useEffect(() => {
    ;(async () => {
      const newUserDetailsPromises = couponUsers.map(async (couponUser) => {
        const userId = couponUser.user_id
        if (userId) {
          const user = await fetchUser(userId)
          if (user) {
            return { ...user, user_id: userId }
          }
        }
      })
      const newUserDetails = await Promise.all(newUserDetailsPromises)
      setUserDetails(newUserDetails.filter(Boolean) as UserType[])
    })()
  }, [couponUsers])

  return (
    <ul className={style.coupon__list}>
      {userDetails.map((user) => (
        <li key={user.user_id} className={style.coupon__container}>
          <div className={style.coupon__inner}>
            <p className={classNames(style.coupon__item, text.font_bold)}>氏名 : {user.name}さん</p>
            <p className={classNames(style.coupon__item, text.font_bold, text.wordBreakAll)}>
              ユーザーID : {user.user_id}
            </p>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default CouponUserList
